// extracted by mini-css-extract-plugin
export default {"Pixel":"styles_Pixel__QP28x","rotate":"styles_rotate__4y7AK"};